'use client';

import { UserAvatar } from '@/components/common/UserAvatar/UserAvatar';
import { useAuth } from '@/hooks/useAuth';
import { Typography } from '@andritzot/metris-web-ui/data-display/typography';
import { Dialog, DialogContent } from '@andritzot/metris-web-ui/feedback/dialog';
import { IconButton } from '@andritzot/metris-web-ui/inputs/icon-button';
import { Box } from '@andritzot/metris-web-ui/layout/content/Box';
import CheckCircleOutlined from '@mui/icons-material/CheckCircleOutlined';
import Close from '@mui/icons-material/Close';
import EmailOutlined from '@mui/icons-material/EmailOutlined';
import GroupOutlined from '@mui/icons-material/GroupOutlined';

import ProfileModel from './ProfileModel';

interface ViewProfileProps {
  handleCloseProfile: () => void;
  visibleProfile: boolean;
}

const ViewProfile = ({ visibleProfile, handleCloseProfile }: ViewProfileProps) => {
  const { user } = useAuth();

  return (
    <Dialog
      open={visibleProfile}
      onClose={handleCloseProfile}
      maxWidth={false}
      slotProps={{ paper: { sx: { width: '23rem', height: '25rem' } } }}
    >
      <Box
        sx={{
          bgcolor: 'primary.main',
          px: 4,
          py: '0.65rem',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <UserAvatar name={user?.name} pictureGuid={user?.pictureGuid} size={48} sx={{ mr: 4 }} />
          <Typography sx={{ fontWeight: 600, fontSize: '1.15rem', color: '#fff', m: 0 }}>{user?.name}</Typography>
        </Box>
        <IconButton
          onClick={handleCloseProfile}
          sx={{ color: 'white', p: '0.5rem', '&:hover': { bgcolor: '#005fa3' } }}
        >
          <Close fontSize="small" />
        </IconButton>
      </Box>
      <DialogContent sx={{ p: 0 }}>
        <ProfileModel icon={EmailOutlined} title="Email" data={user?.email} />
        <ProfileModel
          icon={GroupOutlined}
          title="Resource Group"
          data={user?.resource ? user?.resource : 'Not Assigned to any Resource Group'}
        />
        <Box sx={{ px: 4, py: '0.65rem', display: 'flex' }}>
          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <Typography
              component="h5"
              sx={{ fontWeight: 600, fontSize: '1.15rem', m: 0, p: 0, display: 'flex', alignItems: 'center', gap: 1 }}
            >
              <CheckCircleOutlined fontSize="small" sx={{ color: 'text.secondary' }} />
              Role
            </Typography>
            <Box component="ul" sx={{ listStyleType: 'none', pl: '20px', m: 0 }}>
              {user?.roles?.map((role, index) => (
                <Typography
                  component="li"
                  key={role + index}
                  sx={{
                    fontWeight: 500,
                    fontSize: '0.95rem',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    py: '2px',
                  }}
                >
                  <CheckCircleOutlined fontSize="small" sx={{ color: 'text.secondary' }} />
                  {role}
                </Typography>
              ))}
            </Box>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ViewProfile;
